import { MutationFunction, useMutation, useQueryClient } from 'react-query';
import { QueryKeySet } from './createQueryKeySet';

interface Params<TData, TVariables> {
  mutationFunc: MutationFunction<TData, TVariables>;
  keySet: QueryKeySet;
  keyExtractor(data: TData, vars: TVariables): string | undefined;
}

export const createDeleteMutationHook =
  <TData extends { id?: string }, TVariables>({
    mutationFunc,
    keyExtractor,
    keySet,
  }: Params<TData, TVariables>) =>
  () => {
    const queryClient = useQueryClient();

    return useMutation(mutationFunc, {
      onSuccess(res, vars) {
        const id = keyExtractor(res, vars);
        if (!id) return;

        queryClient.setQueriesData<TData[]>(keySet.lists(), (data = []) => {
          return data.filter((item) => ('id' in item ? item.id !== id : true));
        });

        queryClient.removeQueries(keySet.detail(id));
      },
    });
  };
